import './notFoundPage.scss';

import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { useTranslation } from 'react-i18next';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';
import { FeatureFlag } from '../../store/featureStore/enums/FeatureFlag';
import { useFeatureFlag } from '../../store/featureStore/hooks/useFeatureFlag';
import useThemeStore from '../../store/themeStore/useThemeStore';
import { locator } from '../../testing/e2e-locator/locator';

export function Component(): JSX.Element {
  const { createTheme } = useThemeStore();
  const theme = createTheme();

  const { t } = useTranslation();

  // this should be removed when the legacy UI is fully deprecated.
  const shouldRedirectToNewUI = useFeatureFlag(
    FeatureFlag.ENABLE_OLD_UI_ROUTE_REDIRECT_TO_NEW_UI,
    // explicitly always check flag without userId to avoid default context merging.
    { userId: undefined },
  );

  const redirectToDashboard = (): void => {
    const url = shouldRedirectToNewUI ? '/dashboard/garage' : '/unified';
    window.location.assign(url);
  };

  return (
    <div className="not-found-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <header data-testid={locator.pages.notFound.header.root} />

          <main data-testid={locator.pages.notFound.main.root}>
            <span style={{ marginBottom: '1rem' }}>
              <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
            </span>

            <span style={{ marginBottom: '3rem' }}>
              <h1 data-testid={locator.pages.notFound.main.h1}>
                {t('NotFoundPage.title')}
              </h1>
              <h2 data-testid={locator.pages.notFound.main.h2}>
                {t('NotFoundPage.subtitle')}
              </h2>
            </span>

            <span>
              <LoadingButton
                data-testid={locator.pages.notFound.main.returnHomeButton}
                type="button"
                variant="contained"
                onClick={redirectToDashboard}
              >
                {t('NotFoundPage.returnHome')}
              </LoadingButton>
            </span>
          </main>
        </Box>
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'NotFoundPage';
